import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import PageTracker from '../../../../common/PageTrackerHelper'
import VueElementLoading from 'vue-element-loading'
import moment from 'moment'
import Paginate from "vuejs-paginate";
import { BasicSelect } from 'vue-search-select';

export default {
  name: 'BulkNotifyNoInfoShipments',
  components: {
    VueElementLoading,
    Paginate,
    BasicSelect
  },
  mixins:[PageTracker],
  data: function() {
      return {
        loader:'<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
        ShipmetIds:'',
        batchID:'',
        localuserid:'',
        localusermailid:'',
        localhubdetails:'',
        pagecount: 0,
        pageNo: 1,
        pageSize: 10,
        Intimation:'',
        selectDate:'',
        getShipmetsDetailesData:[],
        NotifyShipmentsflag:false,
        isNotifyLoader: false,
        isNotifyListLoader: false,
        notifyShipmentList: [],
        totalRecords:0,
        getShipmentList: [],
        IsRSC: false,
        hubzoneid: '',
        rscsvcid: '',
        rscownerid: '',
        hubZoneList: [],
        rscSVCList: [],
        rscOwnerList: [],
        HubZonedata: { value: '', text: '' },
        RSCSVCdata: { value: '', text: '' },
        RSCOwnerdata: { value: '', text: '' },
        rscLoader: '',
        zoneLoader: '',
        rscOwnerLoader:'',
        rscownerlistflag: false,
        rscSVCListForDB: [],
        userDataKey : '',
      }
  },
  created: function() {
  },
  async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata');
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localhubdetails = userdetail.hubdetails[0];
    // console.log("userdetail[0]",this.localhubdetails);

    //console.log('Mixin is working for :',result);
    this.getHubZoneData()
  },
  methods : {
     getShipmetsDetailes(shippingIDs){
       this.isNotifyLoader = true;
       let payload={
              "Shipments":shippingIDs,
              "CreatedBy":this.localusermailid,
              "HubId":this.localhubdetails,
              "IntimationFor":this.Intimation
            };
       if(this.IsRSC == true){
        let hubNameForDB = this.rscSVCListForDB.find(obj => obj.value === this.rscsvcid);
         payload.IsRSC = this.IsRSC;
         payload.RSCMasterId = this.rscownerid;
         payload.HubId = this.rscsvcid;
         payload.rscownername = this.RSCOwnerdata.text;
         payload.HubName = hubNameForDB.text;
       }
       axios.post(apiUrl.api_url + 'NoInfoShipments/add',payload)
        .then((response) => {
          let TrackerInfo = {
            projectname:"Last Mile",
            type:"Web",
            userid:this.localuserid,
            username:this.localusermailid,
            meta: {
                "event":"bulkNotify",
                "shipment": shippingIDs.toString(),
                "intimationFor" : this.Intimation
            }
          }
          this.PageTracker(TrackerInfo)
          //console.log("response",response.data.result.length);
          this.getShipmetsDetailesData =response.data.result;
          this.isNotifyLoader = false;
        })
        .catch((httpException) => {
            this.$alertify.error("Record Not found");
            this.isNotifyLoader = false;
            console.error('exception is:::::::::', httpException)
        })

     },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if(result){
          let shipingID=this.ShipmetIds.split(/[\s,]+/);
          let shipmentReqArray = [];
          $.each(shipingID, (key,shipmentId)=>{
            if(shipmentId != ''){
              shipmentReqArray.push(shipmentId.trim())
            }
          })
          if(shipmentReqArray.length > 100){
            this.$alertify.error("maximum 100 shippingID you can enter")
          }
          else {
            this.NotifyShipmentsflag=true;
            this.getShipmetsDetailes(shipmentReqArray);
          }
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    validateForm1(scope) {
      this.$validator.validateAll(scope).then(result => {
        this.pageNo = 1
        this.getAllNotifyMarkedShipmentList()
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    getAllNotifyMarkedShipmentList() {
      if(this.selectDate == '' && this.batchID == '') {
        this.$alertify.error("Please select either Date or BatchID filter.!")
      } else {

      let payload = {
        "pageNo": this.pageNo,
        "pageSize": this.pageSize
      }
      if(this.selectDate != '') {
        payload.startDate = this.selectDate
      }
      if(this.batchID != '') {
        payload.batchId = this.batchID
      }
      this.isNotifyListLoader = true
      axios.post(apiUrl.api_url + 'markedNoInfoShipments/list',payload)
       .then((response) => {
         // console.log("response",response.data.data);
         if(response.data.code == 200) {
           this.notifyShipmentList = response.data.data;
           // let totalRows = response.data.data.count;
           // this.totalRecords = response.data.data.count
           // if (totalRows < 10) {
           //     this.pagecount = 1
           // } else {
           //     this.pagecount = Math.ceil(totalRows / 10)
           // }
         } else {
           this.notifyShipmentList = []
           this.pagecount = 1
         }
         this.isNotifyListLoader = false;
       })
       .catch((httpException) => {
         this.notifyShipmentList = []
           this.$alertify.error("Record Not found");
           this.isNotifyListLoader = false;
           console.error('exception is:::::::::', httpException)
       })
      }
    },
    getPaginationData(pageNum) {
      this.pageNo = pageNum;
      this.getAllNotifyMarkedShipmentList();
    },
    acceptAWBNumber($event){
      let shipingID=$event.target.value.split(/[\s,]+/);
      let shipmentArray = [];
      $.each(shipingID, (key,shipmentId)=>{
        if(shipmentId != ''){
          shipmentArray.push(shipmentId.trim())
        }
      })
      // console.log('shipmentArray ==>>', shipmentArray);
      if(shipmentArray.length > 100){
        this.$alertify.error("maximum 100 shippingID you can enter")
      }
     },
     downLoadShipmentSummary(obj){
       // alert('sucees')
       console.log('downLoadShipmentSummary', obj);
       let reqObj = {
         "BatchId": obj.BatchId,
         "CreatedBy": obj.CreatedBy,
         "CreatedDate": obj.CreatedDate,
         "status": 'All'
       }
       this.isNotifyListLoader = true
       axios.post(apiUrl.api_url + 'lostshipmentinfo/shipmentSummary/list', reqObj)
        .then((response) => {
            if(response.data.code === 200){
              this.getShipmentList = response.data.data;
              let getshipmentObjDetails = [];
              this.getShipmentList.forEach(function(item){
                getshipmentObjDetails.push({
                  "Batch ID":item.BatchId,
                  "Shipping ID": item.ShippingID,
                  "ClientID" : item.ClientID,
                  "NotifyStatus":item.NotifyStatus,
                  "DeliveryDate" : item.DeliveryDate,
                  "Status" : item.Status,
                  "Shipment Status" : item.ShipmentStatus,
                  "OctroiMRP" : item.OctroiMRP,
                  "NetPayment" : item.NetPayment,
                  "HubName":item.HubName,
                  "CreatedBy" : item.CreatedBy,
                  "CreatedDate" : item.CreatedDate,
                  "LastModifiedBy" : item.LastModifiedBy,
                  "LastModifiedDate" : item.LastModifiedDate,
                  "Comments" : item.IntimationFor
                  }
                )
              });
              this.exportCsv(getshipmentObjDetails);

            } else if(response.data.code === 202){
              this.$alertify.error(response.data.data);
              this.getShipmentList = [];
            } else {
              this.$alertify.error("Error while getting shipment Details");
              this.getShipmentList = [];
            }
            this.isNotifyListLoader = false;
        })
        .catch((httpException) => {
            this.isNotifyListLoader = false;
            this.$alertify.error("Unable to get summary details");
            console.error('exception is:::::::::', httpException)
        })
     },
     exportCsv(shipmentObjectdata){
       this.isNotifyListLoader = true
       let csvContent = "data:text/csv;charset=utf-8,";
       var today = new Date();
       var dd = today.getDate();
       var mm = today.getMonth() + 1;
       var yyyy = today.getFullYear();
       var today = dd + "" + mm + "" + yyyy;
       let filename = "ShipmentDetails" + today + ".csv";
       csvContent += [
         Object.keys(shipmentObjectdata[0]).join(";"),
         ...shipmentObjectdata.map(item => Object.values(item).join(";"))
       ]
       .join("\n")
       .replace(/(^\[)|(\]$)/gm, "");

       const data = encodeURI(csvContent);
       this.isNotifyListLoader = false
       const link = document.createElement("a");
       link.setAttribute("href", data);
       link.setAttribute("download", filename);
       link.click();
     },
    clear(){
      this.ShipmetIds='';
      this.batchID='';
      this.Intimation='';
      this.pagecount= 0;
      this.pageNo= 1;
      this.selectDate='';
      this.NotifyShipmentsflag=false;
      this.notifyShipmentList = []
      this.$validator.reset();
      this.errors.clear();
      this.rscSVCList = [];
      this.rscSVCListForDB = [];
      this.RSCSVCdata = { value: '', text: '' };
      this.rscsvcid = '';
      this.rscOwnerList = [];
      this.RSCOwnerdata =  { value: '', text: '' };
      this.rscownerid = '';
      this.HubZonedata = { value: '', text: '' };
      this.hubzoneid = '';
      this.rscownerlistflag = false;
      this.IsRSC = false;
    },
    getHubZone(obj) {
      this.HubZonedata = obj;
      this.hubzoneid = obj.value;
      if(this.hubzoneid){
        this.getRSCListByZoneId(this.hubzoneid);
      }
    },
    getRSCSVC(obj) {
      this.RSCSVCdata = obj;
      this.rscsvcid = obj.value;
      if(this.rscsvcid){
        this.getRSCOwnerListByHubId(this.rscsvcid)
      }
    },
    RSCOwnerobj(obj) {
      this.RSCOwnerdata = obj;
      this.rscownerid = obj.value;
    },
    getHubZoneData() {
      this.zoneLoader = this.loader
      axios.get(apiUrl.api_url + 'external/gethubzonelist', {})
        .then((response) => {
          if (response.data.code == 200) {
            response.data.data.map(hubzonename => {
              this.hubZoneList.push({
                value: hubzonename.hubzoneid,
                text: hubzonename.hubzonename
              });
            });
            this.zoneLoader = ''
          }
          else {
            this.hubZoneList = [];
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    getRSCListByZoneId(hubzoneid) {
      this.rscSVCList = [];
      this.rscSVCListForDB = [];
      this.RSCSVCdata = { value: '', text: '' };
      this.rscsvcid = '';
      this.rscOwnerList = [];
      this.RSCOwnerdata =  { value: '', text: '' };
      this.rscownerid = '';
      let payload = {
        "hubzoneid": hubzoneid
      }
      this.rscLoader = this.loader
      axios.post(apiUrl.api_url + 'external/RSCList/by/ZoneId', payload)
        .then((response) => {
          if (response.data.code == 200) {
            response.data.data.map(element => {
              this.rscSVCList.push({
                value: element.HubID,
                text: `${element.HubName} (${element.HubID})`
              });
              this.rscSVCListForDB.push({
                value: element.HubID,
                text: element.HubName
              });
            });
            this.rscLoader = ''
          }
          else {
            this.rscSVCList = [];
            this.rscSVCListForDB = [];
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    getRSCOwnerListByHubId(rscsvcid){
      this.rscownerlistflag = false;
      this.rscOwnerList = [];
      this.RSCOwnerdata = { value: '', text: '' };
      this.rscownerid = '';
      let payload = {
        "HubId": rscsvcid
      }
      this.rscOwnerLoader = this.loader
      axios.post(apiUrl.api_url + 'external/RSC/OwnerList/by/HubId', payload)
        .then((response) => {
          if (response.data.code == 200) {
            response.data.data.OwnerChangeDetails.map(element => {
              this.rscOwnerList.push({
                value: element.OutSourcingMasterID,
                text: element.OutSourcingName
              });
            });
            if (this.rscOwnerList.length == 0) {
              this.rscownerlistflag = true;
            }
            this.rscOwnerLoader = ''
          }
          else {
            this.rscOwnerList = [];
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },
    clearHubFields(){
      if (this.IsRSC == false) {
        this.HubZonedata = { value: '', text: '' };
        this.hubzoneid = '';
        this.rscSVCList = [];
        this.rscSVCListForDB = [];
        this.RSCSVCdata = { value: '', text: '' };
        this.rscsvcid = '';
        this.rscOwnerList = [];
        this.RSCOwnerdata =  { value: '', text: '' };
        this.rscownerid = '';
        this.rscownerlistflag = false;        
      }
    }
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/components/LOST/BulkNotifyNoInfoShipments/BulkNotifyNoInfoShipments.component.js